export const MAX_CARS_PER_QUOTE = 6;

/**
 * Vehicle ownership types
 */
export enum VehicleOwnership {
  Owned = 'Owned',
  Leased = 'Leased',
  Lien = 'Lien',
}

/**
 * Vehicle usages types
 */
export enum VehicleUsageTypes {
  BusinessUse = 'Business Use',
  WorkCommute = 'Work Commute',
  FarmUse = 'Farm Use',
  FarmBusinessUse = 'Farm Business Use',
  Pleasure = 'Pleasure',
  OffRoad = 'Off-road',
}

export enum CarUsage {
  WorkCommute = 'WorkCommute',
  Pleasure = 'Pleasure',
  // Below are accepted values, but not used in Signup yet.
  // FarmUse = 'FarmUse',
  // FarmBusinessUse = 'FarmBusinessUse',
  // BusinessUse = 'BusinessUse',
}

/**
 * The names of the non-factory equipment
 */
export enum NonFactoryEquipmentNames {
  EnhancedAudio = 'EnhancedAudio', // For Enhanced audio or stereo
  Rims = 'Rims', // For Rims
  CustomPaint = 'CustomPaint', // For Custom paint
  TVConsole = 'TVConsole', // For TV/DVD/Game console
  ShellCover = 'ShellCover', // For Shell/Tonneau Cover
  Modification = 'Modification', // For Modification/Customization
  SpecialtyKit = 'SpecialtyKit', // For Specialty Kit/Conversion
  Other = 'Other', // For Other, need description
}

export enum VehicleInspectionTypes {
  InspectionCompletedNoDamage = 'Inspection Completed: No Damage',
  InspectionCompletedDamaged = 'Inspection Completed: Damaged',
  NoInspectionNeeded = 'No Inspection Needed',
  NoAcknowledgementFromAttached = 'No Acknowledgement Form Attached',
  AcknowledgementFromAttached = 'Acknowledgement Form Attached',
  BillOfSaleForNewVehicle = 'Bill of Sale For New Vehicle',
}

export enum PassiveRestraintTypes {
  None = 'None',
  AutomaticSeatbelts = 'Automatic Seatbelts',
  AirbagDriverSide = 'Airbag (Driver Side)',
  AutoSeatbeltsDriverAirbag = 'Auto Seatbelts / Driver Airbag',
  AirbagBothSides = 'Airbag Both Sides',
  AutoSeatbeltsAirbagBothSides = 'Auto Seatbelts / Airbag Both Sides',
}

export enum PerformanceTypes {
  Standard = 'Standard',
  Sport = 'Sport',
  Intermediate = 'Intermediate',
  HighPerformance = 'High Performance',
}
